import { Modal } from "reactstrap";
import styles from "./index.module.scss";
import SocialMapLogo from "./images/socialmap-logo.png";

const WarningModal = (props) => {
  const { open, setOpen, onConfirm } = props;
  return (
    <>
      <Modal
        isOpen={open}
        backdrop={true}
        toggle={setOpen}
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["supporter-registration-modal"]}
      >
        <div
          style={{
            padding: "100px 100px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            <img src={SocialMapLogo} alt="SocialMap Logo" />
            <div
              style={{
                fontSize: "20px",
                marginLeft: "12px",
              }}
            >
              組織としてアカウント利用
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              marginTop: "6rem",
              marginBottom: "6rem",
            }}
          >
            Social
            mapに未掲載の組織は下記「CSO登録へ進む」を押し、登録を進めてください。
            <br />
            <br />
            ※Social mapに掲載済みかの確認は、
            <br />
            画面左上の検索バーにて、組織名を検索して確認してください。
          </p>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              style={{
                display: "inline-block",
                padding: "15px 17px",
                backgroundColor: "#44CAE1",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                marginBottom: "1rem",
                marginRight: "12px",
              }}
              onClick={onConfirm}
            >
              CSO登録へ進む
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WarningModal;
